export const CREDIT_PAYMENT_URL =
  "https://secure.cardcom.solutions/EA/EA5/dGIpmAdkuEqJAxFxTxtCYw/PaymentSP";
